export default {
  welcome: "Welcome back, {email}",
  subtitle: "Manage your account and view your subscription details here.",
  currentPlan: "Current Plan",
  usageStatistics: "Usage",
  manageTitle: "Manage Your Plan",
  monthlyImages: "Monthly Images",
  monthlyCredits: "Monthly Credits",
  trialCredits: "Lifetime Credits",
  validPeriod: "Valid Period",
  monthlyUsage: "Monthly Usage",
  trialUsage: "Lifetime Usage",
  uploadNewImage: "Upload New Image",
  viewHistory: "View History",
  getSupport: "Get Support",
  upgradeButton: "Upgrade Plan",
  currentPlanBadge: "Current Plan",
  unlimitedUsage: "Unlimited usage available",
  limitReached: "Monthly limit reached",
  creditsUnit: "credits",
  imagesRemaining: "{count} credits remaining this month",
  onlyRemaining: "Only {count} credits remaining this month",
  planType: "Plan Type",
  billingPeriod: "Billing Period",
  billingPeriodMonthly: "Monthly",
  billingPeriodAnnual: "Annual",
  billingPeriodOneTime: "One-time",
  billingPeriodUnknown: "--",
  planCancelAtPeriodEndNotice: "Your plan remains active until the current period ends.",
  creditTotalAvailable: "Total Available",
  creditRemainingGranted: "{remaining} remaining / {granted} granted",
  creditUsed: "{used} used",
  creditValidityRange: "Valid {start} – {end}",
  cycleCreditsUnavailable: "No active monthly credit cycle",
  downgradeButton: "Downgrade",
  plans: {
    free: {
      title: "Free",
      period: "/month",
      features: {
        0: "15 credits on signup",
        1: "Photo-to-reference gap analysis",
        2: "AI-powered post-processing guide",
        3: "Core analysis tools included",
        4: "Unlock select advanced tools with credits",
        5: "Save up to 5 analyses",
      },
    },
    standard: {
      title: "Standard",
      period: "/month",
      features: {
        0: "90 credits / month",
        1: "Unlock gap visualizations with credits",
        2: "Unlock the Pixel Inspector and color palette analysis with credits",
        3: "Save up to 100 analyses",
        4: "Credit top-up packs available",
        5: "Unused credits roll over for one billing cycle while subscribed",
      },
      subtitle: "Everything in Free, plus:",
    },
    pro: {
      title: "Pro",
      period: "/month",
      badge: "Most Popular",
      features: {
        0: "200 credits / month",
        6: "Gap visualizations included",
        1: "Pixel Inspector included",
        2: "Color palette analysis included",
        3: "Exclusive Pro tool: Fine-Tune Slider",
        4: "Save up to 300 analyses",
        5: "Unused credits roll over for one billing cycle while subscribed",
      },
      subtitle: "Everything in Standard, plus:",
    },
  },
  buttonText: {
    currentPlan: "Current Plan",
    upgrade: "Upgrade",
    unavailable: "Unavailable",
    managePlan: "Manage Plan",
    oneOff: "Buy Once",
    periodUnavailable: "This billing period is unavailable",
  },
  billingErrors: {
    checkoutConflict:
      "You already have an active subscription. Manage it to make changes.",
    oneOffConflict:
      "You already have active credits. Please wait until they expire.",
    portalForbidden: "Only active subscriptions can open the billing portal.",
    confirmNotPaid: "Payment confirmation pending. Please refresh later.",
    confirmFailed: "Payment confirmation failed. Please try again later.",
    statusUnavailable:
      "Billing status is temporarily unavailable. Please try again later.",
    statusSyncFailed:
      "We couldn't load your billing status. Purchases are temporarily disabled—please retry.",
    statusAuthError:
      "Your session has expired. Please sign in again to manage billing.",
    checkoutUrlMissing:
      "We couldn't start checkout. Please try again.",
    checkoutCreateFailed:
      "Checkout creation failed. Please try again later.",
    portalUrlMissing:
      "We couldn't open the billing portal. Please try again.",
    portalCreateFailed:
      "Billing portal creation failed. Please try again later.",
    externalRedirect:
      "We couldn't complete the redirect. Please try again or contact support.",
    externalRedirectBlocked:
      "This payment link looks unsafe and was blocked. Please contact support.",
  },
  statusBanner: {
    syncFailed: "Billing status failed to load. Purchases are paused until it recovers.",
    authError: "Your session has expired. Sign in again to continue.",
    retry: "Retry",
    loginAction: "Sign in",
    returnPending: "We're still confirming your payment. You can retry or refresh the page.",
    returnPendingRetry: "Check again",
    dismiss: "Dismiss",
  },
  status: {
    paid: "Active",
    trial: "Trial",
    expired: "Expired",
  },
  paymentCancel: {
    title: "Payment Cancelled",
    description1: "Your payment was cancelled.",
    description2: "You can return to the dashboard to continue exploring PhotoScope.",
    backToDashboard: "Back to Dashboard",
    resumePlans: "Continue browsing plans"
  },
};
